// This file should be isometric ( only code that works in node + browser ) as it's also used by our cypress tests.

import {RouteName} from '../routing'

/**
 * Creates standardized test id for Planner pages
 */
export const pageDataTestId = (routeName: RouteName) => ({'data-test-id': `page_${routeName}`})
